import lodashGet from 'lodash/fp/get';
import type { FieldValues, FormState, Path, UseFormResetField } from 'react-hook-form';
import { ResetButton } from './ResetButton.tsx';

type Props<T extends FieldValues> = {
  name: Path<T>;
  dirtyFields: FormState<T>['dirtyFields'];
  reset: UseFormResetField<T>;
  tagName?: string;
};

export function ResetFieldButton<T extends FieldValues>({ dirtyFields, name, tagName, reset }: Props<T>) {
  function canReset() {
    // For arrays, we need to check if the dirty value is not an empty array
    if (name === 'preferred_ranges' || name === 'lighthouse.advertise_addrs') {
      return lodashGet(name, dirtyFields)?.length > 0;
    }
    return Boolean(lodashGet(name, dirtyFields));
  }

  function onReset() {
    reset(name);
  }

  return <ResetButton onClick={onReset} isShown={canReset()} tagName={tagName} />;
}
